import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ImageCropper from "src/components/ImageCropper";
import Title from "src/components/Title";
import API from "src/services/api";

const ImageCropperSite = () => {
  const [item, setItem] = useState(null);

  const loadData = async () => {
    setItem(null);
    const d = await API.getAllSwipeImages();
    if (d.data) {
      for (const i of d.data) {
        if (i.pathImage === null || i.pathImage === "") {
          setItem(i);
          break;
        }
      }
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const zuschneiden = async (data) => {
    console.log(data);
    await API.cropMedia(item?.id, data);
    loadData();
  };

  if (item === null) {
    return (
      <React.Fragment>
        <Row>
          <Col>
            <Title>Keine Bilder zum zuschneiden</Title>
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Bild zuschneiden</Title>
        </Col>
      </Row>
      <Row>
        <ImageCropper media={item} onZuschneiden={zuschneiden} />
      </Row>
    </React.Fragment>
  );
};

export default ImageCropperSite;
